/** Client-side range/cross-field checks mirroring the contract's own validation (design §8/§9 —
 * "a value outside the range shows the field error … and disables Save"; the 422 mapping of §11
 * stays as the backstop for whatever this misses). */

export function outOfRange(value: number | null, min: number, max: number): boolean {
  return value !== null && (value < min || value > max);
}

/** `interimAckAfterMs`/`agentDeadlineMs` are stored in milliseconds but shown to the merchant in
 * seconds (design §9.10/§9.11). */
export const msToSeconds = (ms: number): number => Math.round(ms / 1000);
export const secondsToMs = (seconds: number): number => Math.round(seconds * 1000);
